var render = function render(_c,_vm){return _c('Route',{class:['MainLogo', _vm.data.class, _vm.data.staticClass],attrs:{"exact":true,"title":"Nogrid","to":"Index"}},[_c('Pic',{attrs:{"alt":"Nogrid - efektyvių saulės elektrinių ekspertai","src":_vm.props.src}}),_c('a',{staticClass:"phone",class:{ black: _vm.props.isScrolled },attrs:{"href":"tel:+370 691 02020"}},[_vm._v(" +370 691 02020 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }